import React from "react";
var __jsx = React.createElement;
import BreadCrumb from "@componentsShared/BreadCrumb";
import { HeroArea } from "./components/HeroArea/HeroArea";
import TrendsList from "./components/TrendsList/TrendsList";
import Pagination from "@/pages/trends/components/Pagination/Pagination";
import stl from "./TrendsComponent.module.css";
import { useTranslation } from "@i18n";
var TrendsComponent = function TrendsComponent(_ref) {
  var trendsList = _ref.trendsList,
    totalPages = _ref.totalPages,
    currentPage = _ref.currentPage;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.mainContainer
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    className: stl.brdCrmb,
    links: [{
      title: t("سيارة ترند", {
        ns: "web_common"
      })
    }]
  }), /*#__PURE__*/React.createElement(HeroArea, null), trendsList.length ? /*#__PURE__*/React.createElement(TrendsList, {
    trendsList: trendsList,
    currentPage: currentPage
  }) : null, totalPages > 1 && /*#__PURE__*/React.createElement(Pagination, {
    pageCount: totalPages,
    currentPage: currentPage
  })));
};
export default TrendsComponent;